import React from 'react';
import { Menu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SearchBox } from '@/components/common';
import { useSiteSettings } from '@/contexts/settings-context';
import styles from './desktop-header.module.css';

interface DesktopHeaderProps {
  onMenuClick?: () => void;
  showSearch?: boolean;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ 
  onMenuClick,
  showSearch = true 
}) => {
  const navigate = useNavigate();
  const { features } = useSiteSettings();

  const canShowSearch = showSearch && features.search;

  const handleSearch = (query: string) => {
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <header className={styles.header}>
      <button 
        className={styles.menuBtn}
        onClick={onMenuClick}
      >
        <Menu size={20} />
      </button>

      {canShowSearch && (
        <div className={styles.search}>
          <SearchBox 
            onSearch={handleSearch}
            placeholder="搜索游戏..."
            showSuggestions={true}
          />
        </div>
      )}
    </header>
  );
};

export default DesktopHeader;
